import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SetErrorBar from "utils/SetErrorBar";
import { ElementProps } from "utils/Types";
import { useLang } from "utils/lang/useLang";

const PermissionGuard = ({ children }: ElementProps) => {
  const lang = useLang();
  const navigate = useNavigate();
  const { permission } = useSelector((s: any) => s.auth);

  const targetStorage = localStorage.getItem("accessToken")
    ? localStorage
    : sessionStorage;
  const accessToken = targetStorage.getItem("accessToken");

  useEffect(() => {
    if (!permission || !accessToken) {
      SetErrorBar(lang.message.adminPermissionRequired);
      navigate("/", { replace: true });
    }
  }, []);

  if (!permission || !accessToken) {
    return null;
  }
  return children;
};

export default PermissionGuard;
